<div class="title">
  <h1>Safety Observation</h1>
</div>
<mat-card style=" margin-left: 2%;margin-right: 2%;">

<div class=dashboard-header>
  <div class=dashboard-Pannel>
    <div style="display: flex;" class ="sc-row-margin">
      <div style="flex: 1 0 17%; text-align: center; display: flex; flex-direction: column" class ="sc-row-margin">

      <div *ngIf="safeIconcolorChange==1" style="flex:1;margin-top: 18px; ">
        <i class=material-icons style="transform: scale(4); color: red;">info</i>
      </div>

      <div *ngIf="safeIconcolorChange==2" style="flex:1;margin-top: 18px; ">
        <i class=material-icons style="transform: scale(4); color: orange;">info</i>
      </div>

      <div *ngIf="safeIconcolorChange==3" style="flex:1;margin-top: 18px; ">
        <i class=material-icons style="transform: scale(4); color: #52ac5a;">info</i>
      </div>

      <div *ngIf="safeIconcolorChange==4" style="flex:1;margin-top: 18px; ">
        <i class=material-icons style="transform: scale(4); color: orange;">info</i>
      </div>
      
    

<div></div>
      <div style="flex: 1; padding-top: 16px; font-size: 32px;margin-top: 3%;">{{safecount}}/{{totalQuestions}}</div>
    </div>
      <div>
        <mat-label (click)="openEditWorkareaDepartmentDialog()" style="font-weight: bold; font-size: 18px;">Department</mat-label>
        <div class=results>{{department}}</div>
        <mat-label (click)="openEditWorkareaDepartmentDialog()" style="font-weight: bold; font-size: 18px;">Workarea</mat-label>
        <div class=results>{{workareas}}</div>
      </div>
    </div>
  </div>


  <div class=dashboard-Pannel>
    <mat-label style="font-weight: bold; font-size: 18px;">Task/Job No. Observed</mat-label>
    <div class=results>{{TaskObserved}}</div>
    <!-- <div style="display: flex;">
      <div class="dashboard">
        <mat-label style="font-weight: bold; font-size: 18px;">Persons Involved</mat-label>
        <i style="padding: 0px 2px" class="material-icons sc-icon" (click) = "openEditPersonInvolvedDialog()"  >add</i>
      
            <div style="font-size: 18px">{{personsInvolved}}</div>
       
    
      
      </div>
    </div> -->

    <div style="display: flex;">
      <div class="dashboard">
        <mat-label style="font-weight: bold; font-size: 18px;">State</mat-label>
        
            <div style="font-size: 18px">{{SiteName}}</div>
       
    
      
      </div>
    </div>
  </div>
 

  <div class=dashboard-Pannel>
    <mat-label style="font-weight: bold; font-size: 18px;">Inspection Date</mat-label>
    <div style="font-weight: bold; font-size: 18px;">{{completedDate}}</div>
    <!-- <div style="display: flex;">
      <div class="dashboard">
        <mat-label style="font-weight: bold; font-size: 18px;">Contractors Involved</mat-label>
        <i style="padding: 0px 2px" class="material-icons sc-icon" (click) = " openContractorsInvolvedDialog()"  >add</i>
        <ng-container *ngIf="contractorsInvolvedList != null">
          <ng-container *ngFor="let ci of contractorsInvolvedList">
            <div style="font-size: 18px">{{ci.ContractorCompanyName}}-{{ci.ContractorStaffName}}</div>
          </ng-container>
    
          </ng-container>
      </div>
    

    </div> -->

       <div style="display: flex;">
      <div class="dashboard">
        <mat-label style="font-weight: bold; font-size: 18px;">Persons Involved</mat-label>
        <i style="padding: 0px 2px" class="material-icons sc-icon" (click) = "openEditPersonInvolvedDialog()"  >add</i>
      
            <div style="font-size: 18px">{{personsInvolved}}</div>
       
    
      
      </div>
    </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label style="font-weight: bold; font-size: 18px;">Inspector</mat-label>
    <div style="font-weight: bold; font-size: 18px;"> {{Inspector}}</div>
    <div style="display: flex;">
      <div class="dashboard">
 
        <mat-label style="font-weight: bold; font-size: 18px;">Contractors Involved</mat-label>
        <i style="padding: 0px 2px" class="material-icons sc-icon" (click) = " openContractorsInvolvedDialog()"  >add</i>
        <ng-container *ngIf="contractorsInvolvedList != null">
          <ng-container *ngFor="let ci of contractorsInvolvedList">
            <div style="font-size: 18px">{{ci.ContractorCompanyName}}-{{ci.ContractorStaffName}}</div>
          </ng-container>
    
          </ng-container>
      

      </div>
    </div>

  </div>
</div>
</mat-card>
<div id="details" style="margin-left: 10%;margin-right: 10%;">
  <div style="margin-top: 32px; width: 100% ">
    <ng-container *ngFor=" let qc of QuestionCategories">
      <table class="sc-resultstable" style="width: 100%;">
        <thead>
          <tr>

            
            <!-- <ng-container *ngFor=" let q of qc.Questions">
           <ng-container *ngIf="(q.SafeOrUnsafe !=2).length >0">
                <td style="text-align: center; width: 10%">
                    <div class="sc-badge " style=" background-color:cornflowerblue;" >N/A</div>
                    <input type="button" style="padding: 8px;width: 61px; height: 28px; background-color: lightgray;font-size: 12px;border-radius: 6px;text-align: center;border: none;
box-shadow: 2px 2px 4px #ccc, -2px 2px 4px #ccc;" value="N/A" />
                </td>
              </ng-container>
            </ng-container> -->
          


            
            <!-- <td  style="text-align: center; width: 10%">
              <div *ngIf="qc.Questions.SafeOrUnsafe !=2 ">
              <input type="button" style="padding: 8px;width: 61px; height: 28px; background-color: lightgray;font-size: 12px;border-radius: 6px;text-align: center;border: none;
                  box-shadow: 2px 2px 4px #ccc, -2px 2px 4px #ccc;" value="N/A" (click) ="ToggleChangeNotApplicable(qc.CategoryId,inspectionId,false)"/></div>
                  <div *ngIf="!qc.Questions.SafeOrUnsafe  !=2">
                    <input type="button" style="padding: 8px;width: 61px; height: 28px; background-color: lightgray;font-size: 12px;border-radius: 6px;text-align: center;border: none;
                        box-shadow: 2px 2px 4px #ccc, -2px 2px 4px #ccc;" value="N/A" (click) ="ToggleChangeNotApplicable(qc.CategoryId,inspectionId,true)"/></div>
            </td> -->
            <td  style="text-align: center; width: 10%">
              <div *ngIf="qc.HasNotApplicable==false">  
              <input type="button" style="padding: 8px;width: 61px; height: 28px; background-color: lightgray;font-size: 12px;border-radius: 6px;text-align: center;border: none;
                  box-shadow: 2px 2px 4px #ccc, -2px 2px 4px #ccc;" value="N/A" (click) ="ToggleChangeNotApplicable(qc.CategoryId,inspectionId,false)"/></div>
                 
                 <div  *ngIf="qc.HasNotApplicable==true"> 
                  <input type="button" style="padding: 8px;width: 61px; height: 28px; background-color: lightgray;font-size: 12px;border-radius: 6px;text-align: center;border: none;
                      box-shadow: 2px 2px 4px #ccc, -2px 2px 4px #ccc;" value="N/A" (click) ="ToggleChangeNotApplicable(qc.CategoryId,inspectionId,true)"/></div>
              

            </td>
       
      

            <td>
              <div class="sc-badge sc-safe">{{qc.CategoryName}}</div>
            </td>
            <td></td>

            <td style="text-align: center;">Follow Up Required</td>
            <td style="text-align: center;">Follow Up Completed</td>
            <td></td>
          </tr>
        </thead>
        <tbody>

          <ng-container *ngIf="qc.Questions != null">
          <ng-container *ngFor="let q of qc.Questions;  index as i">
            <tr>
              <td style="width: 10%">
                <!-- Updating to DropDown-->
                <mat-form-field class="search-select-margin">
                  <mat-select 
                  placeholder="Select Observation Type" 
                  id="{{qc.CategoryId}}{{q.ObservationQuestionId}}" 
                  name="{{qc.CategoryId}}{{q.ObservationQuestionId}}" 
                  [(ngModel)]="q.SafeOrUnsafe" 
                   (selectionChange)="toggleSelectionSafeOrUnsafe($event, q.ObservationQuestionId)"
                   [ngStyle]="{'background-color': getColor(q.SafeOrUnsafe)}"
                   >
                    <mat-option [value]="type.Id"  *ngFor="let type of ObsTypeList"
                    [ngStyle]="{'background-color': type.color}">
                      {{type.Title}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                 <!-- Drop down code eneded-->
                <!-- <div *ngIf="q.SafeOrUnsafe != null && q.SafeOrUnsafe == 0" class="sc-badge sc-unsafe" (click)="toggleSafeOrUnsafe(q.ObservationQuestionId, 1)" >Unsafe</div>
                
               
                <div *ngIf="q.SafeOrUnsafe != null && q.SafeOrUnsafe == 1" class="sc-badge sc-safe" (click)="toggleSafeOrUnsafe(q.ObservationQuestionId, 2)">Safe</div>
                
                
                <div *ngIf="q.SafeOrUnsafe != null && q.SafeOrUnsafe == 2" class="sc-badge" style="background-color:cornflowerblue;" (click)="toggleSafeOrUnsafe(q.ObservationQuestionId, null)"
                  >N/A</div>
                
                <div  *ngIf="q.SafeOrUnsafe == null" class="sc-badge sc-default" (click)="toggleSafeOrUnsafe(q.ObservationQuestionId, 0)" ></div>
                  -->
  
              </td>
  
             
                <ng-container *ngIf="q.QuestionComments != null &&
                (q.QuestionComments.ActionObserved != '' && q.QuestionComments.ActionObserved != null )||(
                q.QuestionComments.Responsibility != '' && q.QuestionComments.Responsibility != null)">
                  <td style="width: 60%; cursor: pointer" >
                  {{q.QuestionName}}
                </td>
                <td style="text-align: center; width: 5%">
                  <i class="material-icons sc-icon sc-icon-safe" (click) = "openAddCommentDialog(q)" >add_comment</i>
                </td>
                </ng-container>
              
              
              
                <ng-container *ngIf="q.QuestionComments == null ||
                (q.QuestionComments.ActionObserved == '' || q.QuestionComments.ActionObserved == null )&&(
                q.QuestionComments.Responsibility == '' || q.QuestionComments.Responsibility == null)">
              <td style="width: 60%">{{q.QuestionName}}</td>
              <td style="text-align: center; width: 5%">
                <i class="material-icons sc-icon" (click) = "openAddCommentDialog(q)">add_comment</i>
              </td>
              </ng-container>
              
  
            
              <td *ngIf="q.FollowUpRequired==false" style="text-align: center; width: 10%"><mat-checkbox  [checked]="false" (click)="ToggleFollowUpRequired(q.ObservationQuestionId, true)"></mat-checkbox></td>
            
              <td *ngIf="q.FollowUpRequired==true" style="text-align: center; width: 10%"><mat-checkbox  [checked]="true"(click)="ToggleFollowUpRequired(q.ObservationQuestionId, false)"></mat-checkbox></td>
            
              
            
              <td  *ngIf="q.FollowUpCompleted == false" style="text-align: center; width: 10%"><mat-checkbox  [checked]="false"(click)="ToggleFollowUpCompleted(q.ObservationQuestionId, true)"></mat-checkbox></td>
                 
              
              <td   *ngIf="q.FollowUpCompleted==true" style="text-align: center; width: 10%"><mat-checkbox  [checked]="true" (click)="ToggleFollowUpCompleted(q.ObservationQuestionId, false)"></mat-checkbox></td>
                 
              
              <!-- <ng-container *ngIf="q.QuestionImageList.length==0"> -->
                
              <td style="text-align: center; width: 5%">
                <i class="material-icons sc-icon" (click)="AddImageDialogComponent(q,'')">camera_alt</i>
              </td>
            
            <!-- </ng-container> -->
           
              <ng-container *ngIf="q.QuestionImageList.length>0">
                <ng-container *ngFor="let img of q.QuestionImageList">
                  <td style="text-align: center; width: 5%">
                    <i class="material-icons sc-icon sc-icon-safe" (click)="AddImageDialogComponent(q,img)">camera_alt</i>
                  </td>
                </ng-container>
                
              </ng-container>
  
  
  
            </tr>
          </ng-container>
          </ng-container>
         
        </tbody>
      </table>

    </ng-container>




  </div>
</div>

<div style="display: flex;flex-direction: row;justify-content: flex-end;">
  <button mat-raised-button color="warn" (click)="DoneClick()">Complete</button>

</div>


